module.exports = __webpack_public_path__ + "static/media/fbmessenger-icon.cb38c92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fbmessenger-icon.png
// module id = 770
// module chunks = 0